import { Box, Flex, SimpleGrid, Stat, StatLabel, StatNumber, useColorModeValue } from "@chakra-ui/react";
import { FC, ReactElement, ReactNode } from "react";
import { FiFile, FiUserCheck, FiUsers } from "react-icons/fi";
import { FaDollarSign, FaFileInvoiceDollar } from "react-icons/fa";
import Number from "components/number-format";

interface PartnerStatisticProps {
    partnerSummary: any
};

interface StatsCardProps {
    title: string;
    stat: ReactNode;
    icon: ReactNode;
}

const PartnerStatisticCard: React.FC<StatsCardProps> = ({ title, stat, icon }) => {
    return (
        <Stat
            px={{ base: 2, md: 4 }}
            py={'2'}
            shadow={'md'}
            border={'1px solid'}
            borderColor={useColorModeValue('teal.700', 'gray.800')}
            rounded={'lg'}
        >
            <Flex justifyContent={'space-between'}>
                <Box pl={{ base: 2, md: 4 }} color={useColorModeValue('teal.700', 'gray.800')}>
                    <StatLabel fontSize={'xs'} fontWeight={'medium'} isTruncated>
                        {title}
                    </StatLabel>
                    <StatNumber fontSize={'large'} fontWeight={'medium'}>
                        {stat}
                    </StatNumber>
                </Box>
                <Box
                    my={'auto'}
                    color={useColorModeValue('teal.700', 'gray.800')}
                    alignContent={'center'}>
                    {icon}
                </Box>
            </Flex>
        </Stat>
    );
}

const PartnerStatistic: FC<PartnerStatisticProps> = ({ partnerSummary }) => {
    return (
        <SimpleGrid columns={{ base: 1, md: 5 }} spacing={{ base: 3, lg: 5 }}>
            <PartnerStatisticCard
                title={'Saldo Akhir'}
                stat={<Number displayType={'text'} prefix={'Rp '} thousandSeparator={true} value={partnerSummary.balance} />}
                icon={<Box display={{ base: 'none', lg: 'flex' }}><FaDollarSign size={'2em'} /></Box>}
            />
            <PartnerStatisticCard
                title={'Total Komisi'}
                stat={<Number displayType={'text'} prefix={'Rp '} thousandSeparator={true} value={partnerSummary.totalCommission} />}
                icon={<Box display={{ base: 'none', lg: 'flex' }}><FaFileInvoiceDollar size={'2em'} /></Box>}
            />
            <PartnerStatisticCard
                title={'Klien'}
                stat={partnerSummary.totalClient}
                icon={<Box display={{ base: 'none', lg: 'flex' }}><FiUsers size={'2em'} /></Box>}
            />
            <PartnerStatisticCard
                title={'Klien Konversi'}
                stat={partnerSummary.totalClientMonitized}
                icon={<Box display={{ base: 'none', lg: 'flex' }}><FiUserCheck size={'2em'} /></Box>}
            />
            <PartnerStatisticCard
                title={'Total Transaksi'}
                stat={partnerSummary.totalTransaction}
                icon={<Box display={{ base: 'none', lg: 'flex' }}><FiFile size={'2em'} /></Box>}
            />
        </SimpleGrid>
    );
};

export default PartnerStatistic;